import { render } from "./productsBox.vue?vue&type=template&id=69a1d66d&scoped=true&ts=true"
import script from "./productsBox.vue?vue&type=script&lang=ts"
export * from "./productsBox.vue?vue&type=script&lang=ts"

import "./productsBox.vue?vue&type=style&index=0&id=69a1d66d&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a1d66d"]])

export default __exports__